import {v4 as guid} from 'uuid';
import * as requestFromServer from './invoicesCrud';
import {callTypes, invoicesSlice} from './invoicesSlice';
import {downloadFileHTTPS} from '../../../../utils';
import * as actionsGlobal from '../../_common/actions/globalMessage/showGlobalMessage';
import {messages as M} from '../../../../_metronic/i18n/messages';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {logUserAction} from '../../../../utils';
import {pages as P} from '../../_common/constants/pages';
import {actionTypes as T} from '../../_common/constants/actionTypes';
import {subjects as S} from '../../_common/constants/subjects';
import {logMessages as L} from '../../_common/constants/logMessages';

export const getInvoicesListIDPrefix = 'getInvoicesList';
const {actions} = invoicesSlice;

const getInvoicesList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getInvoicesListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .findInvoices(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalInvoicesCount: totalCount, pageCount, invoicesList, totalAmount}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount,
        pageCount,
        entities: invoicesList,
        totalAmount
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find invoices';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const getInvoices = getInvoicesList(actions.invoicesFetched);
export const getNextInvoices = getInvoicesList(actions.invoicesAppended);

export const downloadInvoice = ({invoiceTypeID, invoiceNum, name}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .downloadInvoice({invoiceTypeID, invoiceNum})
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      const fileName = `${name}.pdf`;
      try {
        downloadFileHTTPS(data.downloadLink, fileName);
      } catch (exc) {
        console.error('Save Blob method failed with the following exception.');
        console.error(exc);
      }
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const downloadInvoiceReceipts = ({invoiceID, receiptArray, name}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .downloadInvoiceReceipts({invoiceID, receiptArray})
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      const fileName = `${name}.pdf`;

      try {
        if (data.downloadLink instanceof Array) {
          data.downloadLink.forEach(link => {
            downloadFileHTTPS(link, fileName);
          });
        } else {
          downloadFileHTTPS(data.downloadLink, fileName);
        }
      } catch (exc) {
        console.error('Save Blob method failed with the following exception.');
        console.error(exc);
      }
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const sendInvoicesByEmailAction = ({invoiceTypeID, invoiceNum, emailAddress}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .sendInvoicesByEmail({invoiceTypeID, invoiceNum, emailAddress})
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.INVOICES,
        S.INVOICE,
        T.EDIT,
        L.INVOICES_SEND_BY_EMAIL(invoiceNum, emailAddress),
        errorCode
      );
      if (errorCode === 0) {
        dispatch(actionsGlobal.showGlobalMessage(M.OPERATION_COMPLETED));
      } else {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
      }
      return errorCode;
    });
};

export const sendInvoiceReminderAction = ({
                                            invoiceID,
                                            sendToAgent,
                                            sendToCustomer,
                                            sendByMail,
                                            sendBySMS,
                                            sendByWhatsapp,
                                            agentID,
                                            customerID,
                                          }) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .sendInvoiceReminder({
      invoiceID,
      sendToAgent,
      sendToCustomer,
      sendByMail,
      sendBySMS,
      sendByWhatsapp,
    })
    .then(response => {
      const {errorCode, data} = response.data;
      logUserAction(
        P.INVOICES,
        S.INVOICE,
        T.EDIT,
        L.INVOICES_SEND_REMINDER(invoiceID, agentID, customerID,
          sendToAgent, sendToCustomer, sendByMail, sendBySMS, sendByWhatsapp),
        errorCode
      );
      if (errorCode === 0) {
        dispatch(actions.sendReminder({
          invoiceID: invoiceID,
          reminderCount: data.reminderCount,
          lastReminderDate: data.lastReminderDate,
        }));
        dispatch(actionsGlobal.showGlobalMessage(M.OPERATION_COMPLETED));
      } else {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
      }

      return errorCode;
    });
};

export const addReceiptToInvoice = (invoiceID, receiptID) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .addReceiptToInvoice({invoiceID, receiptID})
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.INVOICES,
        S.RECEIPT,
        T.EDIT,
        L.INVOICES_ADD_RECEIPT_TO_INVOICE(receiptID, invoiceID),
        errorCode
      );
      if (errorCode === 0) {
        dispatch(actions.addReceiptToInvoice({invoiceID, receiptID}));
        dispatch(actionsGlobal.showGlobalMessage(M.OPERATION_COMPLETED));
      } else {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
      }
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t send data!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const exportInvoicesFileAction = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getInvoicesFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data.invoicesList;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get data!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const reopenInvoiceAction = invoiceID => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .reopenInvoice(invoiceID)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.INVOICES,
        S.INVOICE,
        T.EDIT,
        L.INVOICES_REOPEN(invoiceID),
        errorCode
      );
      if (errorCode === 0) {
        dispatch(actions.reopenInvoice({invoiceID}));
      } else {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
      }
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t reopen invoice!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const cancelInvoiceAction = (invoiceID, comments, customerEmail) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .cancelInvoice(invoiceID, comments, customerEmail)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.INVOICES,
        S.INVOICE,
        T.EDIT,
        L.INVOICES_CANCEL(invoiceID),
        errorCode
      );
      if (errorCode === 0) {
        dispatch(actions.cancelInvoice({invoiceID}));
        dispatch(actionsGlobal.showGlobalMessage(M.INVOICE_CANCEL_SUCCESS));
      } else {
        dispatch(actionsGlobal.showGlobalMessage(M.INVOICE_CANCEL_ERROR));
      }
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t cancel invoice!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const convertToType1 = (invoiceID) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .convertInvoiceToType1(invoiceID)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.INVOICES,
        S.INVOICE,
        T.CREATE,
        L.INVOICES_CONVERT_TO_TYPE_1(invoiceID),
        errorCode
      );
      if (errorCode === 0) {
        dispatch(actionsGlobal.showGlobalMessage(M.REQUEST_ENDED_SUCCESSFULLY));
      } else {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode.toString()]));
      }
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t convert invoice to type 1!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const convertToType2 = (data) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));
  const {
    invoiceID,
    agentID,
    customerID,
    customerEmail,
    currencyID,
    exchangeRate,
    comment,
    lines
  } = data;

  return requestFromServer
    .convertInvoiceToType2({
      invoiceID,
      agentID,
      customerID,
      customerEmail,
      currencyID,
      exchangeRate,
      comment,
      lines
    })
    .then(response => {
      const {errorCode, data: responseData} = response.data;
      logUserAction(
        P.INVOICES,
        S.INVOICE,
        T.CREATE,
        L.INVOICES_CONVERT_TO_TYPE_2(invoiceID),
        errorCode
      );
      if (errorCode === 0) {
        dispatch(actionsGlobal.showGlobalMessage(M.REQUEST_ENDED_SUCCESSFULLY));
      } else {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode.toString()]));
      }
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t convert invoice to type 2!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const getInvoiceTypes = async () => {
  return requestFromServer.getInvoiceTypes();
};